<script>
  export default {
    data() {
      return {
        // 分页数据
        page: {
          currentPage: 1,
          total: 0,
          pageSize: 10
        },
        // 表格数据
        data: [],
        // curd组件
        option: {},
        // restful 路由地址
        url: '',
        // 顶部搜索数据
        searchParams: {},
        upload: {
          oss: 'ali',
          //阿里云oss配置
          ali: {}
        }
      }
    },
    methods: {
      // 创建事件
      store(row, done, loading) {
        // 去除不必要元素
        this.$refs.crud.option.column.forEach((item) => {
          if (item.display === false || item.addDisplay === false) delete row[item.prop]
        })

        // 如果存在默认参数则带过去
        if (this.defaultParams) row = Object.assign({},  this.defaultParams, row)

        this.api.post(this.url, row).then((re) => {
          loading();
          if (re && re.code === 0) {
            this.initialization();
            this.eventCallback('store');
            done()
          } else re && this.$message.error(re.msg || '网络错误');
        })
      },
      // 更新事件
      update(row, index, done, loading) {
        // 去除不必要元素
        this.$refs.crud.option.column.forEach((item) => {
          if (item.display === false || item.editDisplay === false) delete row[item.prop]
        })

        // 如果存在默认参数则带过去
        if (this.defaultParams) row = Object.assign({}, this.defaultParams, row )

        this.api.post(this.url + '/' + row.id, row, 'PATCH').then((re) => {
            loading();
            if (re && re.code === 0) {
              this.initialization();
              this.eventCallback('update');
              done()
            } else re && this.$message.error(re.msg || '网络错误')
          }
        )
      },
      // 删除事件
      del(row) {
        this.$confirm('确定删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.api.post(this.url + '/' + row.id, row, 'DELETE').then((re) => {
              if (re && re.code === 0) {
                this.initialization();
                this.$message.success(re.msg);
                this.eventCallback('del');
              } else re && this.$message.error(re.msg || '网络错误');

            }
          )
        })
      },
      // 搜索事件
      searchChange(params, done) {
        //搜索后当前页改为1
        this.page.currentPage = 1;
        this.searchParams = params;
        this.initialization(done)
      },
      // 刷新事件
      refreshChange(obj) {
        this.searchParams = obj.searchForm;
        this.initialization()
      },
      // 初始化事件
      initialization(callback) {
        // 拼装分页数据
        let url = this.url;
        if (this.page) url = this.url + '?pageSize=' + this.page.pageSize + '&page=' + this.page.currentPage;

        // 默认参数
        if (this.defaultParams) this.searchParams = Object.assign({}, this.searchParams, this.defaultParams)

        this.api.get(url, this.searchParams).then((re) => {
          if (re.code === 0) {
            this.data = re.data
            if (this.page && re.total && re.pageSize) {
              this.page.total = re.total;
              this.page.pageSize = Number(re.pageSize);
            }
          } else re && this.$message.error(re.msg || "出错了!")
          callback && callback()
        })
      },
      // 改变每页条数事件
      sizeChange(val) {
        this.page.currentPage = 1;
        this.page.pageSize = val;
        this.initialization()
      },
      // 改变页码事件
      currentChange(val) {
        this.page.currentPage = val;
        this.initialization()
      },
      // 增删改查事件回调
      eventCallback(type) {
        console.log('增删改查事件回调' + type)
      },
      // 上传前的回调
      uploadBefore: function (file, done) {
        this.$AVUE.ali = this.$store.getters.aliOss();
        done(new File([file], window.utils.getRandFilename(file.name), {type: file.type}))
      },
      // 权限管理-判断该路由中是否有该操作
      isShow(operation) {
        if (this.$route.meta.operation)
          for (let key in this.$route.meta.operation) {
            if (this.$route.meta.operation[key].title === operation) return true;
          }
        return false;
      },
      // 从服务器获取字典
      getDic(code) {
        return this.config.baseURL + '/dic?code=' + code;
      },
      // 导出Excel文件统一处理
      excelExport(filename = new Date().getTime(), field) {
        this.$confirm('导出将由服务器后端执行，需要时间等待，完成后会在右上角提示下载，该导出包含以下内容: ' + field, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const message = this.$notify({
            title: '通知',
            message: '服务器处理中...',
            showClose: false,
            duration: 0
          });
          this.api.get(this.url + '/export?filename=' + filename, this.searchParams).then((re) => {
            message.close();
            if (re.code === 0) {
              let url = this.config.baseURL + '/excel/download/' + re.data;
              this.$notify({
                title: '导出成功!',
                dangerouslyUseHTMLString: true,
                type: 'success',
                duration: 0, // 不会自动关闭的消息
                message: filename + '数据导出完成 下载导出文件:<a target="_blank" href="' + url + '">下载' + filename + 'Excel</a>'
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          });
        });
      },
      // 导入Excel 成功回调
      excelImportSuccess() {
        this.initialization();
      }
    },
    created() {
      // 默认路由
      if (this.url.length === 0) this.url = this.$route.path;
      // 初始化数据
      this.initialization()
    },
    watch: {
      // 默认参数
      defaultParams(newVal, oldVal) { // 监听修改
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.initialization()
        }
      }
    }
  }
</script>
